var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08668 4.18002L11.1939 2.15637M12.398 1L11.1939 2.15637L12.398 1ZM6.61225 6.55636C6.92312 6.85092 7.17024 7.20163 7.33938 7.5883C7.50853 7.97496 7.59636 8.38993 7.59783 8.80933C7.59929 9.22873 7.51435 9.64426 7.34791 10.032C7.18146 10.4197 6.9368 10.772 6.628 11.0686C6.3192 11.3652 5.95236 11.6001 5.54862 11.76C5.14487 11.9198 4.71219 12.0014 4.27548 12C3.83877 11.9986 3.40667 11.9142 3.00405 11.7518C2.60142 11.5893 2.23624 11.352 1.92951 11.0535C1.32634 10.4537 0.992581 9.65044 1.00013 8.81665C1.00767 7.98286 1.35591 7.18527 1.96985 6.59567C2.58379 6.00607 3.41429 5.67163 4.2825 5.66439C5.1507 5.65714 5.98714 5.97767 6.61165 6.55693L6.61225 6.55636ZM6.61225 6.55636L9.08668 4.18002L6.61225 6.55636ZM9.08668 4.18002L10.8928 5.91457L13 3.89092L11.1939 2.15637L9.08668 4.18002Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.a4a96f3ea73db0ee1f43e8089bbdda63.svg";
export { ForwardRef as ReactComponent };